import React from 'react';
import { View } from 'react-native';
import { manual_name } from '../../../utils/DictionaryManagementUtils';
import SwitcherPanel from '../Buttons/SwitcherPanel';
import RecipientRadioPanel from './RecipientRadioPanel';

//= ========================================================================

const ManualRecipientSwitcher = ({
  language, onConfigChanged, manualRecipients,
}) => {
  const onManualRecipientFieldValueChanged = (manualField, value) => {
    manualRecipients.manual_fields_list[manualField] = value;
    onConfigChanged();
  };

  const onRecipientConfigurationChanged = (recipient_key, value) => {
    manualRecipients[recipient_key] = value;
    onConfigChanged();
  };

  return (
    <View>
      {Object.keys(manualRecipients.manual_fields_list).map((manualField) => (
        <View style={{ marginBottom: 16 }}>
          <SwitcherPanel
            key={`SwitcherPanel${manualField}`}
            text={manualRecipients[manualField]}
            value={manualRecipients.manual_fields_list[manualField]}
            onValueChanged={(value) => {
              onManualRecipientFieldValueChanged(manualField, value);
            }}
            alwaysOn={manualField === manual_name}
          />
          {manualRecipients[`search_from_list_${manualField}`] !== undefined && manualRecipients.manual_fields_list[manualField]
            && (
              <RecipientRadioPanel
                language={language}
                key_configuration={`search_from_list_${manualField}`}
                isSelected={manualRecipients[`search_from_list_${manualField}`]}
                onValueChanged={onRecipientConfigurationChanged}
              />
            )}
        </View>
      ))}
    </View>
  );
};
export default ManualRecipientSwitcher;
